import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-delete-item',
  imports: [],
  templateUrl: './delete-item.component.html',
  styleUrl: './delete-item.component.css',
})
export class DeleteItemComponent {

  @Input() width: number = 20;
  @Input() height: number = 20;

}
